import { useGetEmployeeMeQuery } from "../../../common/api/employee";
import Skeleton from "react-loading-skeleton";
import { EmployeeInfoCardsWidget } from "@hatch-digital-nl/abs-storybook/legacy";
import editImage from "../../../common/images/edit.svg";
import {
    setIsEditEmployeeModalOpen,
    setSelectedEmployee,
} from "../../../modals/EditEmployeeModal/EditEmployeeModalSlice";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { JSX, useEffect } from "react";
import { getEmployeeDetailItems } from "../utils/getEmployeeDetailItems";

export const DataManagementContent = (): JSX.Element | null => {
    const {
        data: employeeMeData,
        isLoading: employeeMeDataIsLoading,
        isFetching: employeeMeDataIsFetching,
        refetch: refetchEmployeeMe,
    } = useGetEmployeeMeQuery({});
    const dispatch = useAppDispatch();

    const { isPatchEditEmployeeSuccess } = useAppSelector(
        (state) => state.editEmployeeModal,
    );

    useEffect(() => {
        if (isPatchEditEmployeeSuccess) {
            refetchEmployeeMe();
        }
    }, [isPatchEditEmployeeSuccess, refetchEmployeeMe]);

    if (employeeMeDataIsLoading || employeeMeDataIsFetching) {
        return <Skeleton count={1} height={"37rem"} borderRadius={"1.5rem"} />;
    }

    if (!employeeMeData) {
        return null;
    }

    return (
        <EmployeeInfoCardsWidget
            header={{
                title: "Persoonlijke gegevens",
                button: {
                    text: "bewerken",
                    iconUrl: editImage,
                    onClick: () => {
                        dispatch(setIsEditEmployeeModalOpen(true));
                        dispatch(setSelectedEmployee(employeeMeData));
                    },
                },
            }}
            items={getEmployeeDetailItems(employeeMeData)}
        />
    );
};
